// extracted by mini-css-extract-plugin
export default {"internalNewsContainer":"InternalNews_internalNewsContainer__TxzyW","intNewsTitle":"InternalNews_intNewsTitle__oa+Vn","intNewsSubtitle":"InternalNews_intNewsSubtitle__alzQp"};